import React, { useState, useMemo } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { MeBadge, getLastUpdatedDateColorWeeks } from "../../../dashboard-util/dashboard-utils";
import PropTypes from "prop-types";
import {
  renderTooltipHeader,
  createColumnMenu,
  formatLastUpdatedDate,
  renderlastUpdatedTooltipHeader,
  renderLabelWithInfoTooltipHeader,
} from "../../../dashboard-util/dashboard-telerik-helper/dashboard-telerik-helper";
import { OverallCapacityCell } from '../../levfin-helper'
import { FluentAvatar } from "../../../../../components/FluentUI/Fluent-Avatar";

const LevfinBankerSummaryGrid = ({ summaryItem = {}, onOverallCapacityChange, fromStafferModal = false }) => {
  const [summaryState, setSummaryState] = useState({ sort: [], filter: null });
  const gridData = useMemo(() => {
    if (!summaryItem) return [];
    return [
      {
        ...summaryItem,
        UserName: summaryItem.Banker,
      },
    ];
  }, [summaryItem]);

  const columnMenu = createColumnMenu(gridData);

  if (!summaryItem) {
    return null;
  }

  return (
    <div className="summary-grid-wrapper">
      <Grid
        data={gridData}
        sort={summaryState.sort}
        filter={summaryState.filter}
        onSortChange={(e) => setSummaryState({ ...summaryState, sort: e.sort })}
        onFilterChange={(e) =>
          setSummaryState({ ...summaryState, filter: e.filter })
        }
        className="levfin-time-log-summary-grid"
        resizable={true}
      >
        <Column
          field="Banker"
          title={renderTooltipHeader("Banker")}
          columnMenu={columnMenu}
          cell={(props) => {
            return (
              <td className="summary-cell k-table-td avatar-cell">
                <div className="avatar-content">
                  <FluentAvatar name={summaryItem.Banker} color="brand" size={24} />
                  <span>{summaryItem.Banker}</span>
                  {!fromStafferModal && <MeBadge />}
                </div>
              </td>
            );
          }}
        />
        <Column
          field="OverallCapacity"
          title={renderTooltipHeader("Overall Capacity")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td overall-capacity">
              <OverallCapacityCell
                value={summaryItem?.OverallCapacity}
                taskExists={summaryItem?.OverallCapacityTaskId != null}
                onChange={onOverallCapacityChange}
                isBanker={true}
                canEdit={fromStafferModal ? summaryItem?.CanEdit : true}
              />
            </td>
          )}
        />
        {summaryItem?.NumberOfDeals?.map((item, index) => (
          <Column
            field={`${item.Key}`}
            title={renderTooltipHeader(`# of ${item.Key}`)}
            columnMenu={columnMenu}
            cell={(props) => (
              <td className="summary-cell k-table-td">
                {item.Value ?? "—"}
              </td>
            )}
          />
        ))}

        <Column
          field="Total"
          title={renderTooltipHeader("Total")}
          columnMenu={columnMenu}
          cell={(props) => (
            <td className="summary-cell k-table-td">
              {props.dataItem.Total ?? "—"}
            </td>
          )}
        />
        <Column
          field="LastUpdated"
          title={renderlastUpdatedTooltipHeader("Last Updated")}
          columnMenu={columnMenu}
          filter="date"
          cell={(props) => (
            <td className="background-white k-table-td" style={{ color: getLastUpdatedDateColorWeeks(props.dataItem.LastUpdated) }}>
              <span>{formatLastUpdatedDate(props.dataItem.LastUpdated)}</span>
            </td>
          )}
        />
      </Grid>
    </div>
  );
};

export default LevfinBankerSummaryGrid;

LevfinBankerSummaryGrid.propTypes = {
  summaryItem: PropTypes.shape({
    Banker: PropTypes.string,
    OverallCapacity: PropTypes.number,
    OverallCapacityTaskId: PropTypes.number,
    CanEdit: PropTypes.bool,
    NumberOfDeals: PropTypes.arrayOf(
      PropTypes.shape({
        Key: PropTypes.string,
        Value: PropTypes.number,
      })
    ),
    Total: PropTypes.number,
    LastUpdated: PropTypes.string,
  }),
  onOverallCapacityChange: PropTypes.func.isRequired,
  fromStafferModal: PropTypes.bool,
};